//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "../../api/common";
export default {
    data() {
        return {
            dutyid: this.$route.query.dutyid,
            headphoto: this.$route.query.headphoto,//医生头像
            dutiesname: '',//职称
            hospitaname: this.$route.query.hospitaname,//所属医院
            visitdoctorname: '',//医生名
            visitorganization: '',//就诊医院
            visittime: '',//预约时间
            timeframe: '',//上午/下午
            registrationfee: 0,//挂号费
            whatday: '',
            whatdayarr: ['日','一','二','三','四','五','六'],
            code: this.$store.state.userInfo.patientcode,
            patientid: this.$store.state.userInfo.id,//患者id
            patientname: this.$store.state.userInfo.patientname,//患者姓名
            telephone: this.$store.state.userInfo.telephone,//手机号
            openid: this.$store.state.userInfo.patientcode,//openid
            doctorvisitid: this.$route.query.dutyid,//医生出诊id
            isSubmit: true,
        }
    },
    methods: {
        getDoctorVisit(){
            let params = {
                parameters: this.dutyid,
            };
            this.$doRequest("/api/doctorvisit/getDoctorVisit", params, res=>{
                let visit = res[0];
                this.dutiesname = visit.dutiesname;
                this.visittime = common.timestampToTime(visit.visittime,2);
                this.visitorganization = visit.visitorganization;
                this.timeframe = visit.timeframe;
                this.registrationfee = visit.registrationfee;
                this.visitdoctorname = visit.visitdoctorname;
                this.whatday = this.whatdayarr[visit.whatday]
            });
        },
        //去支付
        paySubmit(){
            if(this.isSubmit){
                this.isSubmit = false;
                let params = {
                    patientid: this.patientid,
                    patientname: this.patientname,
                    telephone: this.telephone,
                    openid: this.openid,
                    doctorvisitid: this.dutyid
                };
                this.$doRequest("/api/AppointmentRegister/buyAppointmentRegister", params, res=>{
                    var resp=res;
                    let _this = this;
                    WeixinJSBridge.invoke('getBrandWCPayRequest', resp.parameters.weiPayReturnEntiey.weiAppLetEntity,function(res){
                        if(res.err_msg=='get_brand_wcpay_request:ok'){
                            _this.$toastMsg('预约挂号支付成功');
                            _this.$router.push({ path: "/myRegistered"});
                        }else{
                            _this.$toastMsg('预约挂号支付失败');
                            if(resp.parameters.bookingregister){
                                let params = [resp.parameters.bookingregister.id];
                                _this.$doRequest("/api/bookingregister/delete", params, res=>{
                                    _this.isSubmit = true;
                                });
                            }
                        }
                    });
                });
            }
        },
        init(){
            this.getDoctorVisit();
        }
    },
    //生命周期之创建完成
    created: function() {
        document.title = '预约挂号';
        this.$isLogin(window.location.search.substr(1), this.init);
    }
}



// WEBPACK FOOTER //
// ./src/views/orgMakeRegisterPay/index.vue